var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCoin2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 165,
    height: 247,
    viewBox: "0 0 165 247",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.7837 16.6689C22.6273 40.1893 18.1304 87.237 31.8139 137.05C45.4974 186.863 73.3718 225.026 100.983 235.989L103.236 244.161L125.86 237.95C159.923 228.593 173.07 168.256 155.201 103.187C137.331 38.1176 95.2308 -7.06829 61.2071 2.29456L38.5833 8.50484L40.7837 16.6689Z",
    fill: "#F1F333",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M132.58 109.408C114.715 44.3326 72.6105 -0.838829 38.5374 8.51513C4.46439 17.8691 -8.67507 78.2063 9.18994 143.282C27.055 208.358 69.1593 253.529 103.232 244.175C137.305 234.821 150.445 174.484 132.58 109.408Z",
    fill: "#F1F333",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M112.612 114.88C98.5268 63.5711 67.4551 27.3725 43.2116 34.028C18.9682 40.6835 10.7334 87.6727 24.819 138.981C38.9046 190.29 69.9766 226.488 94.22 219.833C118.464 213.177 126.698 166.188 112.612 114.88Z",
    fill: "#F1F333",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoin2);
export default __webpack_public_path__ + "static/media/coin2.50c7a669efb3aded81db2bf292fd7272.svg";
export { ForwardRef as ReactComponent };